import React, { useEffect, useRef, useState } from "react";
import style from '@/styles/RealtimeChart.module.scss';

export default function RealtimeChart({ data, id="myChart" }: { data: number[], id?: string }) {

    const minVal = Math.min(...data) - 5;
    const maxVal = Math.max(...data) + 5;

    useEffect(() => {
        const canvas = document.getElementById(id) as HTMLCanvasElement;
        var baseCanvasWidth = canvas.width * 0.8;
        var baseCanvasHeight = canvas.height * 0.8;

        const valueRange = (maxVal - minVal);

        canvas.style.width = baseCanvasWidth+"px";
        canvas.style.height = baseCanvasHeight+"px";
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = "#2e2e2e";

        ctx.fillRect(0, 0, canvas.width, canvas.height);
        const pointWidth = canvas.width / data.length;
        const pointHeight = canvas.height / valueRange;

        const startLine = (Math.ceil(maxVal / 10) * 10) + 20;

        const lineCnt = 8;
        const rawStep = valueRange / lineCnt;
        const lineStep = Math.ceil(rawStep / 5) * 5;

        ctx.strokeStyle = "#6d6e6e";
        ctx.beginPath();
        for (let i = startLine; i >= minVal - 10; i -= lineStep) {
            ctx.moveTo(60, canvas.height - (i - minVal) * pointHeight);
            ctx.lineTo(canvas.width, canvas.height - (i - minVal) * pointHeight);
        }
        ctx.stroke();
        ctx.closePath();

        // writing values to the chart
        ctx.fillStyle = "white";
        ctx.font = "25px Arial";
        for (let i = startLine; i >= minVal - 10; i -= lineStep) {
            ctx.fillText(i.toFixed(0), 5, canvas.height - (i - minVal) * pointHeight + 8);
        }

        ctx.strokeStyle = "white";
        ctx.beginPath();
        ctx.moveTo(canvas.width, canvas.height - (data[0] - minVal) * pointHeight);
        for (let i = 1; i < data.length; i++) {
            ctx.lineTo(canvas.width - i * pointWidth, canvas.height - (data[i] - minVal) * pointHeight);
        }
        ctx.stroke();
        ctx.closePath();

        console.log('rendered');
    }, [data, minVal, maxVal]);

    return (
        <div>
            <canvas className={style.canvas} id={id} width="800" height="500"></canvas>
        </div>
    );

}